import { render, staticRenderFns } from "./GrowthProgramOverview.vue?vue&type=template&id=3e2f1a54&scoped=true"
import script from "./GrowthProgramOverview.vue?vue&type=script&lang=js"
export * from "./GrowthProgramOverview.vue?vue&type=script&lang=js"
import style0 from "./GrowthProgramOverview.vue?vue&type=style&index=0&id=3e2f1a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f1a54",
  null
  
)

export default component.exports